import { combineReducers } from 'redux';
import toolTypeReducer from './toolTypeReducer';
import whiteBoardCollectionReducer from './whiteBoardReducer';

const RootReducer = combineReducers({
  toolTypeProps: toolTypeReducer,
  whiteBoardProps: whiteBoardCollectionReducer
});

export default RootReducer;